import { Expose } from "../serialization/class-transformer/decorators";

export class BaseMessage {

    @Expose()
    code!: string;

    @Expose()
    description!: string;

    @Expose()
    propertyName!: string;

    @Expose()
    objectName?: string;

    @Expose()
    uuid?: string;

    get type(): string {
        return '';
    }
}
